
import { Grid, Filter, Page, Sort, RecordClickEventArgs, parentsUntil, Toolbar } from '@syncfusion/ej2-grids';
import { Query, DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { classList, closest } from '@syncfusion/ej2-base';
import { DatePicker } from '@syncfusion/ej2/calendars';
import { DateHelper } from '../Helpers/DateHelper';
import { Toastr } from '../Helpers/Toastr';
import { LogbookDataService } from '../DataService/LogbookDataService';
import { LogbookItemFilterStatus } from '../Models/LogbookItemFilterStatus';
import { SyncfusionDropdownHelper } from '../Helpers/SyncfusionDropdownHelper';
import { SyncfusionGridHelper } from '../Helpers/SyncfusionGridHelper';


export class LogbookManager {

    constructor(private containerElement: JQuery) { }

    private logbookGrid : Grid;

    public initialize() {
        var self = this;

        Grid.Inject(Filter, Page, Sort, Toolbar);

        self.initializeLogbookItemsTable();
    }

    private initializeLogbookItemsTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var logbookItemsContainer = self.containerElement.find('#logbook-items-container');

        var gridElement : JQuery<HTMLElement> = self.containerElement.find('#LogbookGrid');
        var gridContentElement : JQuery<HTMLElement> = gridElement;

        let data: DataManager = new DataManager({
            url: '/api/company/logbook/items',
            adaptor: new WebApiAdaptor,
        }); 

        var creationDateElem;
        var creationDateObj;

        self.logbookGrid = new Grid(
        {
            height: '100%',
            dataSource: data,
            columns: [
                { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},
                { field: 'CreationDateTimeString', headerText: 'Created',  width: 140, allowEditing: false, allowFiltering: true,
                    filterBarTemplate: {
                        create: () => { 
                            creationDateElem = document.createElement('input'); 
                            return creationDateElem; 
                        }, 
                        write: (args) => {
                            const persistedValue =
                                args?.value
                                ?? self.logbookGrid?.filterSettings?.columns
                                    ?.find((x: any) => x.field === 'CreationDateTimeString')
                                    ?.value;

                            creationDateObj = new DatePicker({
                                value: SyncfusionGridHelper.parseDatePickerValue(persistedValue),
                                format: 'dd-MM-yyyy',
                                floatLabelType: 'Never',

                                change: (args) => {
                                    const dateValue = DateHelper.DateToString(args.value);

                                    if (dateValue == undefined) {
                                        self.logbookGrid.removeFilteredColsByField(
                                            'CreationDateTimeString'
                                        );
                                    } else {
                                        self.logbookGrid.filterByColumn(
                                            'CreationDateTimeString',
                                            'equal',
                                            dateValue,
                                            undefined,
                                            true
                                        );
                                    }
                                }
                            }); 
                            creationDateObj.appendTo(creationDateElem); 
                        } 
                    }
                },
                { field: 'Enquiry', headerText: 'Enquiry', allowFiltering: false, width: 200, autoFit: true, template: '${getLogbookItemLink(data.DocHeaderId, data.CustomerReference, data.OurReference)}' },
                { field: 'Status', headerText: 'Status', allowFiltering: true, width: 100, autoFit: true, filterBarTemplate: SyncfusionDropdownHelper.templateEnumOptionsDropDown(() => self.logbookGrid, 'Status', Object.keys(LogbookItemFilterStatus).filter(key => isNaN(Number(key))), 
                        (args) => {
                            self.logbookGrid.filterByColumn(args.item.parentElement.id.replace('_options', ''), 'equal', args.value, undefined, true);
                    }, 'New'), defaultValue: 'New'},
                { field: 'Message', headerText: 'Message', allowFiltering: false, autoFit: true},
                { field: 'AcknowledgedByUserName', headerText: 'Acknowledged by', allowFiltering: false, width: 150, autoFit: true },
                { field: 'AcknowledgeDateTimeString', headerText: 'Acknowledged at', allowFiltering: false, width: 150, autoFit: true },
                { field: 'AcknowledgeButton', headerText: '', allowFiltering: false, width: 50, autoFit: true, template: '${getLogbookItemAcknowledeButton(data.Status)}' },

            ],
            allowSorting: true,
            allowPaging: true,
            allowFiltering: true,
            allowSelection: false,
            allowResizing: false,
            enablePersistence: true,
            toolbarTemplate: '#toolbar-template',
            pageSettings: { pageSize: 50 },
            created: () => {
                gridContentElement = gridContentElement.find('.e-content')

                loadingContainer.addClass('d-none');
                logbookItemsContainer.removeClass('d-none');
            },
            dataBound: () => {
                gridContentElement.find('[data-bs-toggle="tooltip"]').tooltip({ container: 'body', trigger: 'hover' });
            },
            recordClick: (args: RecordClickEventArgs) => {
                if (args.target != undefined && args.rowData != undefined) {
                    var parsedTarget = $(args.target); 
                    var logbookItemId = args.rowData["Id"];
                
                    if(parsedTarget.data('action') == 'acknowledge-log-item' || parsedTarget.parent().data('action') == 'acknowledge-log-item' && logbookItemId != undefined) {
                        parsedTarget.prop('disabled', true);

                        LogbookDataService.acknowledgeLogbookItem(logbookItemId, (result) => {
                            Toastr.Success('Success', 'You\'ve successfully acknowledged this logbook record');
                            self.logbookGrid.filterByColumn("Id", 'equal', `${crypto.randomUUID()}`, undefined, true)
                        })
                    }
                }
            }
        });

        self.logbookGrid.appendTo('#LogbookGrid');
        var toolbar = this.containerElement.find('#toolbar-template');
        if(toolbar != undefined && toolbar.length > 0) {
            var clearFiltersButton = toolbar.find('#clear-filters-button');
            clearFiltersButton.off('click').on('click', () => {
                self.logbookGrid.pageSettings.currentPage = 1;
                self.logbookGrid.clearFiltering();
                self.logbookGrid.refreshHeader();
            })
        }
    }
}